import {ContactsTableController} from "../../../contact/controller/contacts_table/ContactsTableController";
import {Partner} from "../../model/Partner";
import {PartnerServiceName} from "../../../utils/names/serviceNames";
import {LoaderStatusValue} from "../../../loader/service/loaderStatus";
import {ToastNotificationService} from "../../../utils/ToastNotificationService";
import {PartnerService} from "../../service/PartnerService";

export class PartnersTableComponent extends ContactsTableController<Partner> {

    static instance = ContactsTableController.instanceFactory(PartnerServiceName, PartnersTableComponent);

    constructor($scope: any,
                $location: angular.ILocationService,
                $mdDialog: angular.material.IDialogService,
                loader: LoaderStatusValue,
                notificationService: ToastNotificationService,
                contactService: PartnerService) {
        super($scope, $location, $mdDialog, loader, notificationService, contactService);
    }

    protected profileUrl(id: number) {
        return `/partner_profile/${id}`;
    }

    protected title() {
        return "Partners";
    }

}